module.exports = __webpack_public_path__ + "media/images/icons/illustration/friend-25a1755c5aa755ae1ab8abf9cf34aac6.svg";